/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const state = {
    showAlertDialog: false,
    alertMessage: Object
}

const getters = {}

const mutations = {
    setShowAlertDialog(state, status) {
        state.showAlertDialog = status
    },
    setAlertMessage(state, message) {
        state.alertMessage = message
    }
}

const actions = {
    commitToggleAlertDialog({
        commit
    }, {
        status,
        message
    }) {
        commit("setShowAlertDialog", status)
        commit("setAlertMessage", message)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}